import React, { useState, useEffect } from "react"
import MetaTags from 'react-meta-tags';
import { useSelector } from "react-redux";

import { Link, useHistory } from "react-router-dom"
import { Container, Row, Col, Button, Input, Label, Card, CardBody } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

import moment from 'moment';
import { companyListCall } from "../../crud/auth.crud"
import Loading from "pages/Custom/Loading";

const TreatmentManagement = () => {

  const [dataList, setDataList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchCondition, setSearchCondition] = useState({})
  const [page, setPage] = useState(1)
  const [refresh, setRefresh] = useState(false)
  const [isListEnd, setIsListEnd] = useState(false)
  const [listCount, setListCount] = useState(0)
      
  useEffect(() => {
    const scBody = document.getElementById("sc-body");
    if (!scBody) return;
    const handleScroll = () => {
      const scrollPosition = scBody.scrollTop;
      const scrollHeight = scBody.scrollHeight - scBody.clientHeight;
      if (scrollPosition >= scrollHeight - 1) {
        setPage(page + 1)
      }
    }
    scBody.addEventListener('scroll', handleScroll)

    return () => {
      scBody.removeEventListener('scroll', handleScroll)
    }
  }, [dataList])
  
  const getDataList = async () => {
    if (isLoading || isListEnd)
      return

    setIsLoading(true)
    try {
      const params = {
        page: page,
        type: 'treatment',
        search: searchCondition.companyName || '',
        number: searchCondition.companyNumber || ''
      }
      const response = await companyListCall(params);
      if (response.status === 200) {
        setListCount(response.data.count)
        const content = response.data.results || []
        const newList = [...dataList, ...content]
        if (page === 1) {
          setDataList(content)
        } else {
          setDataList(newList)
        }
        if (newList.length >= response.data.count) {
          setIsListEnd(true)
        }
      }
      setIsLoading(false)
      setRefresh(false)
    } catch (error) {
      console.error(error);
      setIsLoading(false)
      setRefresh(false)
    }
  }

  const changeSearchCondition = (key, value) => {
    setSearchCondition(prev => ({ ...prev, [key]: value }))
  }

  const onSearch = async() => {
    if (page === 1) {
      setRefresh(true)
    } else {
      setPage(1)
    }
    setIsListEnd(false)
  }
      
  useEffect(() => {
    if (refresh)
      getDataList()
  }, [refresh])
  
  useEffect(() => {
    if (!isListEnd)
      setRefresh(true)
  }, [page, isListEnd])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>처리장 관리 / 웨이스트버스</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs maintitle="Home" title="사업장 관리" breadcrumbItem="처리장 관리" />

          <div className="d-flex w-100 gap-30 align-items-center mb-3">
            <div className="email-rightbar flex-grow-1">
              <Card className="mb-0">
                <CardBody className="padding-0">
                  <table className="input-table">
                    <tbody>
                      <tr>
                        <td className="col-10 padding-left-8 primary-bg white-text font-size-12">상호검색</td>
                        <td className="col-20">
                          <input className="waver-input-box font-size-12 w-100 border-radius-0" placeholder="상호명을 입력하세요." value={searchCondition.companyName} onChange={(e) => {
                            changeSearchCondition('companyName', e.target.value)
                          }} />
                        </td>
                        <td className="col-10 padding-left-8 primary-bg white-text font-size-12">사업자번호 검색</td>
                        <td className="col-20">
                          <input className="waver-input-box font-size-12 w-100 border-radius-0" placeholder="사업자번호를 입력하세요." value={searchCondition.companyNumber} onChange={(e) => {
                            changeSearchCondition('companyNumber', e.target.value)
                          }} />
                        </td>
                        <td className="col-10 padding-left-8 primary-bg white-text font-size-12"></td>
                        <td className="col-20"></td>
                      </tr>
                    </tbody>
                  </table>
                </CardBody>
              </Card>
            </div>
            <div className="d-flex flex-direction-column align-items-end">
              <button type="button" className="custom-btn btn-dark-gradient border-radius-0 white-text border-none margin-right-0" onClick={() => {
                onSearch()
              }}>
                검색
              </button>
            </div>
          </div>

          <div className="d-flex justify-content-between align-items-center mb-2 margin-top-56">
            <p className="mb-0 font-size-16"><span className="font-weight-bold">처리장 목록</span> [ 건수 : {listCount}건 ]</p>
          </div>
          <Row>
            <Col xs="12">
              <div className="email-rightbar mb-3">

                <Card>
                  <CardBody style={{ padding: 0, borderRadius: 4, overflow: 'hidden' }}>
                    <div id={"sc-body"} style={{maxHeight: 660}} className="table-responsive">
                      <table className="table table-hover table-centered table-nowrap mb-0 chart-table">
                        <thead className="chart-thead">
                          <tr>
                            <th scope="col">No</th>
                            <th scope="col">상호</th>
                            <th scope="col">대표자</th>
                            <th scope="col">사업자번호</th>
                            <th scope="col">전화번호</th>
                            <th scope="col">이메일</th>
                          </tr>
                        </thead>
                        <tbody className="chart-tbody">
                          {dataList.map((item, index) => {
                            return (
                              <tr key={'treatment_management_' + index} onClick={()=>{
                              }}>
                                <td>{item.id}</td>
                                <td>{item.name}</td>
                                <td>{item.username}</td>
                                <td>{item.company_number}</td>
                                <td>{item.phone}</td>
                                <td>{item.email}</td>
                              </tr>
                            )
                          })
                          }
                          {dataList.length === 0 &&
                            <tr>
                              <td scope="row" colSpan="14">데이터가 없습니다.</td>
                            </tr>
                          }

                        </tbody>
                      </table>
                    </div>
                  </CardBody>
                  {isLoading && <Loading />}
                </Card>

              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default TreatmentManagement
